import TeamsIcon from '../assests/images/teamsIcon.svg';
import PortfoliohealthIcon from '../assests/images/portfolioLinkIcon.svg';

export const statusOptions = ['Not Started', 'In Progress', 'Completed'];
export const revertStatusOptions = ['Completed', 'Revert to In Progress'];

export const TPO_ADMIN = 'TPO_ADMIN';
export const CORE_USER = 'CORE_USER';
export const GENERAL_USER = 'GENERAL_USER';

export const Brand_strategy = 'Brand Strategy';
export const REGIONAL_USER_TYPE = 'Region';
export const CHANNEL_USER_TYPE = 'Channel';
export const DOLLAR_FORMAT_COLUMNS = [
  'CY REVENUE',
  'NET REVENUE',
  'LY REVENUE',
  'REVENUE',
  'GROSS SALES',
  'ON-TICKET TRADE SPEND',
  'NET INVOICE SALES',
  'OFF-TICKET TRADE SPEND',
  'COGS',
  'GROSS PROFIT',
  'TOTAL S&D',
  'NET PROFIT',
  'TOTAL WASTE ($)'
]; // 1
export const COMMA_FORMAT_COLUMNS = ['']; // 4
export const COMMA_FORMAT_COLUMNS_WITH_PERCENT = [
  'REVENUE GROWTH %',
  'UNIT GROWTH %',
  'GS vs LY',
  'NS vs LY',
  'CASES vs LY',
  'NR vs LY',
  'WEIGHT vs LY'
]; // 2

export const ZERO_DECIMAL_FORMAT_COLUMNS_WITH_PERCENT = [
  'REVENUE GROWTH',
  'VOLUME GROWTH',
  'DISTRIBUTION %',
  'FACILITY %'
];
export const ZERO_DECIMAL_FORMAT_COLUMNS = [
  'CY UNITS',
  'UNITS',
  'LY UNITS',
  'VOLUME QTY',
  'STORE COUNT',
  'FACILITY COUNT',
  'CASES',
  'WEIGHT',
  'FACILITY COUNT L12W'
];

export const ONE_DECIMAL_FORMAT_COLUMNS_WITH_PERCENT = ['PROFIT %', 'FLOWBACK %'];
export const ONE_DECIMAL_FORMAT_COLUMNS_WITHOUT_PERCENT = [''];
export const ONE_DECIMAL_FORMAT_COLUMNS = ['']; // 1234.5
export const ONE_DECIMAL_COMMA_FORMAT_COLUMNS_WITH_PERCENT = [
  'CY PROFIT %',
  'Profitpercentage',
  'UNITS vs LY',
  'GP %',
  'NP vs LY',
  'NET PROFIT %'
]; // 1,234.5% (123456) // 3

export const TWO_DECIMAL_FORMAT_COLUMNS_WITH_PERCENT = ['WASTE %', 'TOTAL WASTE %'];
export const TWO_DECIMAL_FORMAT_COLUMNS_WITHOUT_PERCENT = [''];
export const TWO_DECIMAL_FORMAT_COLUMNS = [''];
export const TWO_DECIMAL_COMMA_FORMAT_COLUMNS_WITH_PERCENT = ['CY WASTE %', 'Wastepercentage'];

export const FINANCIAL_KPI_COLUMNS = [
  'revenue',
  'revenue growth',
  'volume',
  'volume qty',
  'flowback %',
  'waste %',
  'complexity',
  'store count',
  'distribution %',
  'facility %',
  'volume growth',
  'price',
  'price growth',
  'margin',
  'margin growth',
  'margin %',
  'PackCount',
  'GrossSales',
  'GSvsLY',
  'OnTicketTradeSpend',
  'NetInvoiceSales',
  'NSvsLY',
  'OffTicketTradeSpend',
  'COGS',
  'GrossProfit',
  'TotalSD',
  'NetProfit',
  'TotalWaste',
  'TotalWaste%',
  'Profit%',
  'Profitpercentage',
  'UnitsvsLY',
  'GP%',
  'NPvsLY',
  'NetProfit%',
  'CYProfit%',
  'Wastepercentage',
  'CYWastePercentage',
  'FacilityCountL12W',
  'FacilityCount',
  'Cases',
  'Weight',
  'WeightvsLY',
  'RevenueGrowth',
  'UnitGrowth',
  'GSvsLY',
  'PackCount',
  'CurrentYearRevenue',
  'LastYearRevenue',
  'GPPercent',
  'CurrentYearProfitPercentage',
  'CurrentYearUnits',
  'LastYearUnits',
  'CasesvsLY',
  'profit %',
  'facility count',
  'MaterialNetWeightQuantity',
  'NetRevenue',
  'NetVolume'
];

export const KPI_HIGHLIGHTER = {
  level_attribute_name: {
    columns: ['revenue growth', 'volume growth', 'profit %', 'waste %'],
    color: '#d7e5f8'
  }
};

export const masterConditionOptions = [
  { displayText: 'Segment', id: 'Segment' },
  { displayText: 'Brand', id: 'Brand' },
  { displayText: 'Sub Brand', id: 'Sub Brand' },
  { displayText: 'Sub Category', id: 'Sub Category' },
  { displayText: 'Flavour', id: 'Flavour' },
  { displayText: 'Size', id: 'Size' },
  { displayText: 'Pack Count', id: 'Pack Count' },
  { displayText: 'Pack Type', id: 'Pack Type' },
  { displayText: 'Brand Strategy', id: 'Brand Strategy' }
];
export const masterActionOptions = [
  { displayText: 'Segment', id: 'Segment' },
  { displayText: 'Sub Category', id: 'Sub Category' },
  { displayText: 'Innovation Type', id: 'Innovation Type' },
  // { displayText: 'Launch Period', id: 'Launch Period' },
  { displayText: 'Discontinued Period', id: 'Discontinued Period' },
  { displayText: 'Hold Flag', id: 'Hold Flag' },
  { displayText: 'Strategic Importance', id: 'Strategic Importance' },
  { displayText: 'Must Carry Flag', id: 'Must Carry Flag' },
  { displayText: 'Brand Strategy', id: 'Brand Strategy' },
  { displayText: 'Supply Chain Complexity', id: 'Supply Chain Complexity' },
  { displayText: 'Channel Importance', id: 'Channel Importance' }
];

const levelOptions = [
  { displayText: 'High', id: 'High' },
  { displayText: 'Medium', id: 'Medium' },
  { displayText: 'Low', id: 'Low' }
];

const flagOptions = [
  { displayText: 'Yes', id: 'Yes' },
  { displayText: 'No', id: 'No' }
];

export const weightDropdownOptions = [
  { displayText: 'Net Revenue', id: 'Net Revenue' },
  { displayText: 'Household Penetration', id: 'Household Penetration' },
  { displayText: 'Market Share', id: 'Market Share' },
  { displayText: 'Profit', id: 'Profit' },
  { displayText: 'SKU Reduction', id: 'SKU Reduction' }
];

export const goalMetricOptions = [
  { displayText: 'Revenue Growth', id: 'Revenue Growth' },
  { displayText: 'Market Share Growth', id: 'Market Share Growth' },
  { displayText: 'Profit Growth', id: 'Profit Growth' },
  { displayText: 'Waste Reduction ', id: 'Waste Reduction ' },
  { displayText: 'SKU Reduction', id: 'SKU Reduction' }
];

export const dropdownOptionColumnNames = {
  'Innovation Type': [
    { displayText: 'LTO', id: 'LTO' },
    { displayText: 'Refresh', id: 'Refresh' },
    { displayText: 'Reframe', id: 'Reframe' },
    { displayText: 'Breakthrough', id: 'Breakthrough' },
    { displayText: 'New Product', id: 'New Product' },
    { displayText: 'Core', id: 'Core' }
  ],
  'Hold Flag': flagOptions,
  'Strategic Importance': levelOptions,
  'Must Carry Flag': flagOptions,
  'Supply Chain Complexity': levelOptions,
  'Channel Importance': levelOptions
};

export const masterQuillAutoCompleteOptions = ['Segment', 'Sub Category', 'Brand Strategy'];

export const updateLogsColumns = [
  { id: 'title', label: 'TITLE' },
  { id: 'impactedSKUCount', label: 'IMPACTED SKU COUNT' },
  { id: 'status', label: 'STATUS' },
  { id: 'createdTime', label: 'UPDATED DATE' },
  { id: 'viewlogs', label: 'ACTION' }
];

export const homeScreenQuickLinks = [
  {
    icon: PortfoliohealthIcon,
    name: 'Portfolio Master Data',
    description: 'Maintain and manage centralized repository of SKU',
    link: '/portfolio/master-data'
  },
  {
    icon: PortfoliohealthIcon,
    name: 'PO Manual Data Upload',
    description: 'Upload product portfolio data and initiate PO cycle analysis',
    link: '/upload'
  },
  {
    icon: TeamsIcon,
    name: 'Teams',
    description: 'Create and view teams to facilitate optimisation',
    link: '/setup-team'
  },
  {
    icon: TeamsIcon,
    name: 'Global Cycles',
    description: 'View all cycles',
    link: '/portfolio/cycle-trigger'
  }
];

export const timeFrameOptions = [
  { displayText: 'L13', id: 'L13' },
  { displayText: 'YTD', id: 'YTD' }
];

export const cycleToggleOptions = ['Test Cycle'];

export const cycleDatesInputOptions = ['Start Date', 'End Date'];

export const homePageCycleTableColumns = [
  { id: 'cycleName', label: 'CYCLE NAME', type: 'link' },
  { id: 'startYearPeriod', label: 'CYCLE START' },
  { id: 'endYearPeriod', label: 'CYCLE END' },
  { id: 'calendarPhase', label: 'PHASE' },
  { id: 'status', label: 'RUN STATUS', type: 'status' },
  { id: 'lastModifiedSince', label: 'LAST MODIFIED', type: 'date' }
];

export const calendarColors = [
  '#B3DACB',
  '#F8C471',
  '#AED6F1',
  '#F5B7B1',
  '#D7BDE2',
  '#F9E79F',
  '#82E0AA',
  '#85C1E9',
  '#FAD7A0',
  '#F1948A'
];

export const feedbackCollationColumnOrder = {
  'sku name': 1,
  'tposku': 2,
  'upc/gtin': 3,
  'segment': 4,
  'sub-category': 5,
  'brand': 6,
  'sub-brand': 7,
  'packsize': 8,
  'complexity': 9,
  'channel importance': 10,
  'quadrant': 11,
  'classification': 12,
  'national classification' : 12,
  'action reco': 13,
  'delist rank': 14,
  'revenue': 15,
  'revenue growth': 16,
  'volume qty': 17,
  'volume growth': 18,
  'profit %': 19,
  'flowback %': 20,
  'waste %': 21,
  'store count': 22,
  'distribution %': 23,
  'facility count': 24,
  'facility %': 25
};